import { Component, Inject, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { fadeInOut } from '@shared/src/animations';
import { HomeController } from '@shared/src/controllers/home/home.controller';
import { OpenUuidExwork } from '@shared/src/controllers/open/OpenUuidExwork';
import { OpenRouteController } from '@shared/src/controllers/open/open.route.controller';
import { SocketController } from '@shared/src/controllers/socket/socket.controller';
import { SystemController } from '@shared/src/controllers/system/system.controller';
import { HTags } from '@shared/src/datatypes/HTags';
import { BookingSimpleDto } from '@shared/src/dtos/booking/BookingSimpleDto';
import { OpenRouteChangeDriverInfoAndPlatesDto } from '@shared/src/dtos/open/OpenRouteChangeDriverInfoAndPlatesDto';
import { HTagsDefined } from '@shared/src/enums/HTagsDefined';
import { AlertService, HString, SharedSaveButtonEvent } from '@shared/src/public-api';
;

@Component({
    selector: 'shared-exwork-driverplate-component',
    templateUrl: './shared.exwork.driverplate.component.html',
    styleUrls: ['./shared.exwork.driverplate.component.scss'],
    animations: [fadeInOut]
})
export class SharedExworkDriverPlateComponent implements OnInit {

    constructor(protected socketController: SocketController, public router: Router, protected activatedRoute: ActivatedRoute,
        @Inject('HomeController') protected homeController: HomeController,
        public openRouteController: OpenRouteController, public systemController: SystemController,
        @Inject('AlertService') public alertService: AlertService) {


    }

    ngOnInit(): void {
  
    }

    @Output() changeEditMode: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() refreshData: EventEmitter<boolean> = new EventEmitter<boolean>();

    @Input()
    public uuid: string;
   
    public __data: OpenUuidExwork;
    @Input()
    public set data(value: OpenUuidExwork) {
        if (this.__data === value)
            return;
        this.__data = value;
        if (this.data != null && this.data.editMode) {
            this.startEditmode();
        } else {
            this.editMode = false;
        }
    }
    public get data(): OpenUuidExwork {
        return this.__data;
    }
    
    public algoAFer(): boolean {
        if (this.data && this.data.phaseList && this.data.phaseList.length > 0)
            return true;
        return false;
    }

    public esBooking(): boolean {
        if (this.data != null)
            if (HTags.contains(this.data.internalTags, HTagsDefined.HTAG_requiresBooking))
                return true;
        return false;
    }

    public requereixBooking(): boolean {
        if (this.esBooking())
            if (this.data != null && (this.data.bookingId == null || this.data.bookingId == 0))
                return true;

        return false;
    }
    
    public __editMode: boolean;
    @Input()
    public set editMode(value: boolean) {
        if (this.__editMode === value)
            return;
        this.__editMode = value;
        this.changeEditMode.next(value);
    }
    public get editMode(): boolean {
        return this.__editMode;
    }

    public plateA: string;
    public plateB: string;
    public plateC: string;
    public transportationRegistrationCode: string;
    public driverName: string;
    public driverLegalIdentification: string;
    public driverPhone: string;
    public carrierName: string;
    public carrierCode: string;
    public carrierLegalIdentification: string;
    public carrierAddress: string;
    public startEditmode() {
        this.editMode = true;

        this.plateA = this.data.plateA;
        this.plateB = this.data.plateB;
        this.plateC = this.data.plateC;
        this.transportationRegistrationCode = this.data.transportationRegistrationCode;
        this.driverName = this.data.driverName;
        this.driverLegalIdentification = this.data.driverLegalIdentification;
        this.driverPhone = this.data.driverPhone;
        this.carrierCode = this.data.carrierCode;
        this.carrierName = this.data.carrierName;
        this.carrierLegalIdentification = this.data.carrierLegalIdentification;
        this.carrierAddress = this.data.carrierAddress;
    }

    save($event: SharedSaveButtonEvent) {
        this.openRouteController.setExworkDriverInfoAndPlates(this.uuid,
            OpenRouteChangeDriverInfoAndPlatesDto.build(this.driverName, this.driverLegalIdentification, this.driverPhone, this.plateA, this.plateB, this.plateC, this.transportationRegistrationCode, this.carrierCode, this.carrierName, this.carrierLegalIdentification, this.carrierAddress)).subscribe(data => {
                this.editMode = false;
                this.refreshData.next(true);
                if ($event)
                    $event.callback();
            });
    }

    cancel() {
        this.editMode = false;
    } 

    public pretty(value: any): string {
        return JSON.stringify(value);
    }

}
